import {
  array,
  boolean,
  func,
  Infer,
  nullable,
  number,
  object,
  optional,
  string,
  union,
} from 'superstruct';
import { DomElement, Url } from '../types/commonTypes';
import { SwipeGamesItemSchema } from './swipe';

export const MiniGamesResponseTypeSchema = object({
  gameData: union([string(), number()]),
  placeHolderDom: optional(DomElement),
});

export const MiniGamesCallbackFnSchema = object({
  nonce: string(),
  gameResponse: MiniGamesResponseTypeSchema,
});

export const MiniGamesListConfigSchema = object({
  remoteApiEnable: boolean(),
  remoteApiEndPoint: optional(Url),
  requestHeaders: object(),
  routeParams: object(),
  queryString: object(),
  gameList: array(SwipeGamesItemSchema),
  gamesOverride: optional(nullable(array(union([string(), number()])))),
});

export const MiniGamesConfigSchema = object({
  domElement: DomElement,
  pagesToShow: array(string()),
  launchOnLoad: optional(boolean()),
  gameListConfig: MiniGamesListConfigSchema,
  gameLaunchConfig: object({
    remoteApiEnable: boolean(),
    remoteApiEndPoint: Url,
    requestHeaders: object(),
    routeParams: object(),
    queryString: object(),
  }),
  urlCallbackFn: optional(nullable(func())),
});

export type MiniGamesListConfig = Infer<typeof MiniGamesListConfigSchema>;
export type MiniGamesConfig = Infer<typeof MiniGamesConfigSchema>;
